module.exports = __webpack_public_path__ + "img/linkBack.30524ffe.png";